<template>

  <v-sheet color="secondary" dark tile>

    <portal to="footer-filters">
      <v-btn color="primary" height="80" @click="clearAllFilters" block>
        <v-icon left>mdi-restart</v-icon>
        Reset Filters
      </v-btn>
    </portal>

    <div class="overflow-y-auto mx-1">

      <div>
        <h4 class="subtitle-1">Filter By Location</h4>
        <Locations table-name="serviceAreas" field-name="Location"></Locations>
      </div>

      <div class="mt-5">
        <h4 class="subtitle-1">Filter By Speed (Mbps)</h4>
        <Speed table-name="serviceAreas" field-name="Speeds_mbps"></Speed>
      </div>

    </div>

  </v-sheet>

</template>

<script>
import Locations from '../../filters/Locations.vue';
import Speed from '../../filters/Speed.vue';

export default {

  name: 'General.Filters',

  components: {
    Locations,
    Speed,
  },

  data: () => {
    return {
    };
  },

  beforeDestroy() {
  },

  methods: {

    clearAllFilters() {
      this.$store.dispatch('CLEAR_SELECTED_FILTERS');
    },

  },

};
</script>
